import { Box } from '@mantine/core';
import { useGetColor } from '../hooks';
import type { IconPropsType } from './types';

export const BoldIcon = ({ size = 24, sx, color, ...props }: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 12H12.6667C14.8758 12 16.6667 10.2091 16.6667 8C16.6667 5.79086 14.8758 4 12.6667 4H6.10561C6.04728 4 6 4.04728 6 4.10561V12ZM6 12H14C16.2091 12 18 13.7909 18 16C18 18.2091 16.2091 20 14 20H6.11881C6.05319 20 6 19.9468 6 19.8812V12Z"
        stroke={iconColor}
        strokeWidth="2.5"
      />
    </Box>
  );
};
